import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Alert } from 'antd'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { usrRole } from '../../utils/dataUtil'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'
import { req_single_eca_lockedTag, req_page_eca_english_activity_participates_academic, req_edit_eca_activity_participate } from '../../api'

class StudentMyselfPoints extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        deviceWidth: 0,
        loading: false,
        userLevel: 'NORMAL',
        items: [],
        item: {},
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'None',
        searchValue: '',
        filterStatus: '',
        domnloadFile: '',

        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),
        lockStudentViewStatus: 'N'
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_init_data()
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////


    api_init_data = async () => {
        const { token } = this.props.user
        // 開關[查詢學習點數] //學生
        const pointssearch = await req_single_eca_lockedTag('POINSTS_SEARCH', token)
        this.setState({ lockStudentViewStatus: pointssearch.isLocked })
    }


    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus, nowAcademicYear, nowAcademicSemester } = this.state
        const { token, userCode, role } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true, items: [] })
        const result = await req_page_eca_english_activity_participates_academic(userCode, userLevel, nowAcademicYear, nowAcademicSemester, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })

        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(items);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_modify_item = async (item) => {
        const { token } = this.props.user
        await req_edit_eca_activity_participate(item, token)
        //this.api_page_items(this.current)
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '學年',
                dataIndex: 'signSchoolYear',
                width: 20,
                responsive: ['md'],
            },
            {
                title: '學期',
                dataIndex: 'signSemester',
                width: 20,
                responsive: ['md'],
            },
            {
                title: '姓名',
                dataIndex: 'participantsName',
                width: 40,
                responsive: ['md'],
            },
            {
                title: '自學項目',
                dataIndex: 'activityTitle',
                width: 100,
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.2em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '得點',
                width: 30,
                render: (item) => {
                    const { getPoints, isMutliCourseParticipant, getLevel } = item
                    return (
                        <>
                            <div>{getPoints}</div>            
                            <div>
                                {isMutliCourseParticipant === 'N' ? '' : (<><p/><select name="getLevel" id="getLevel" defaultValue={getLevel} onChange={(e) => this.handleChange(e, item)} key={getLevel} >
                                    <option value="1">歸屬大一</option>
                                    <option value="2">歸屬大二</option>
                                </select></>)}
                            </div>
                        </>
                    )
                },
            },

        ]
    }


    // 操作互動處理 //////////////////////////////////////////////

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    handleChange(event, item) {
        const target = {
            participantsUid: item.participantsUid,
            setLevel: event.target.value,
            condition: 'LEVEL'
        }
        this.api_modify_item(target)
    }

    /////////////////////////////////////////////////////////////   
    render() {
        const { loading, items, pagination, lockStudentViewStatus } = this.state
        return (
            <>
                <Card>
                    {lockStudentViewStatus === 'N' ? (<Table
                        bordered
                        scroll={{ y: 480 }}
                        loading={loading}
                        rowKey='id'
                        dataSource={items}
                        onChange={this.handle_table_change}
                        pagination={{
                            ...pagination,
                            responsive: true,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            pageSizeOptions: [5, 10, 20, 50, 100],
                            // onChange: this.api_page_applycase,
                            onShowSizeChange: this.handle_page_size_change
                        }}
                        columns={this.columns}
                    />) : (<Alert message="尚未開放查詢" type="info" showIcon />)}
                </Card>
            </>
        )
    }
}


export default connect(
    state => ({ user: state.user }),
    {}
)(StudentMyselfPoints)